import React from 'react'
import Iframe from 'react-iframe'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { PcSpWidth } from '../shared/Constant'
import { Typography } from '../atoms/Typography'

type Props = {
  caption: string
  url: string
}

export const YouTube: React.VFC<Props> = ({ caption, url }) => (
  <Container>
    <Video>{url && <Iframe url={url} width="100%" height="100%" />}</Video>
    <Caption>{caption}</Caption>
  </Container>
)

const Container = styled.div`
  width: 100%;
  max-width: ${`${PcSpWidth.MOBILE_L}px`};
  margin: 0 auto;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    flex: 1;
    max-width: 50%;
  }
`

const Video = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
`

const Caption = styled(Typography)`
  text-align: center;
  color: ${Styles.color.primary[400]};
  font-size: ${Styles.fontSize[300]};
  font-weight: ${Styles.fontWeight.semiBold};
  line-height: ${Styles.lineHeight[400]};
  letter-spacing: ${Styles.letterSpacing[400]};
  margin: ${Styles.spacing[6]} 0 0;
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    font-size: ${Styles.fontSize[400]};
  }
`
